import { useEffect } from 'react';
import { selectUserAgent } from '@redux/slices/header';
import { useAppSelector } from '@app/redux/hooks';
import { useWindowSizing } from '@hooks/useSizeWindow';
import dynamic from 'next/dynamic';

const MobileMenu = dynamic(() => import('./Mobile'));
const DesktopHeader = dynamic(() => import('./Desktop'));

const Header = () => {
  const mobileWindow = useWindowSizing(990);
  const { isMac, isIphone, isIpad, isIos } = useAppSelector(selectUserAgent);

  useEffect(() => {
    if (isMac || isIphone || isIpad || isIos) {
      document.body.classList.add('mac-oc');
    }
  }, [isIos, isIpad, isIphone, isMac]);

  return !mobileWindow ? <DesktopHeader /> : <MobileMenu />;
};

export default Header;
